import {
  OCRModeEnum,
  OcrProcessSourceEnum,
  UploadTypeEnum,
  OcrOperationSourceEnum,
} from '@/shared/tools/ocr/enum';
import type { OCRBothInfo } from '@/shared/tools/ocr/types';

/** 【异步】统一获取身份证信息入口 */
export const asyncCaptureIdentity = async (
  uploadType: UploadTypeEnum,
  mode: OCRModeEnum,
  processSource: OcrProcessSourceEnum,
  operationSource: OcrOperationSourceEnum,
): Promise<OCRBothInfo> => {
  const { captureIdentity } = await import(/* webpackChunkName: "async-ocr-capture-identity" */ '@/shared/tools/ocr/capture');

  return captureIdentity(uploadType, mode, processSource, operationSource);
};
